import React from "react";

export default function CopyDoneThickIcon({
	color = "#50B0F9",
	width = 16,
	height = 16,
}) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.584 4.88086H15.0245C15.2581 4.88086 15.4822 4.97367 15.6474 5.13888C15.8126 5.30409 15.9054 5.52817 15.9054 5.76181V15.4523C15.9054 15.6859 15.8126 15.91 15.6474 16.0752C15.4822 16.2404 15.2581 16.3332 15.0245 16.3332H6.21494C5.98129 16.3332 5.75722 16.2404 5.59201 16.0752C5.4268 15.91 5.33398 15.6859 5.33398 15.4523V5.76181C5.33398 5.52817 5.4268 5.30409 5.59201 5.13888C5.75722 4.97367 5.98129 4.88086 6.21494 4.88086H6.65541"
				stroke={color}
				strokeWidth="2.20238"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
			<path
				d="M12.8227 4H8.41797V5.7619H12.8227V4Z"
				stroke={color}
				strokeWidth="1.7619"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
			<path
				d="M7.97656 11.4881L9.29799 12.8095L13.2623 8.84521"
				stroke={color}
				strokeWidth="1.32143"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
		</svg>
	);
}
